import { ObservableArray, View } from "binder"
import { column, PopupColumnsEditorViewModel, singleColumnCustomEnum } from "./popupColumnsEditor-viewModel"

export class PopupColumnsEditorView extends View<PopupColumnsEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-EF1EA587-829D-4A99-882B-09C948A00173"
    }
    loadHtml(): string {
        let element = require('./popupColumnsEditor.html').default;
        let style = require('./popupColumnsEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set columns(v: ObservableArray<column>) { this._columns = v; } public get columns(): ObservableArray<column> { return this._columns;} private _columns: ObservableArray<column>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set selectedColumnEnumValues(v: ObservableArray<singleColumnCustomEnum>) { this._selectedColumnEnumValues = v; } public get selectedColumnEnumValues(): ObservableArray<singleColumnCustomEnum> { return this._selectedColumnEnumValues;} private _selectedColumnEnumValues: ObservableArray<singleColumnCustomEnum>;

    public addColumn(){
        this.dataContext.addColumn();
    }
    public confirm(){
        this.dataContext.confirm();
    }
    public back(){
        this.dataContext.back();
    }

    orderEnumValues(){
        this.dataContext.orderEnumValues();
    }

    addCustomEnum(){
        this.dataContext.addCustomEnum();
    }
}
